import { sendBackgroundMessage, sendChatMessage } from '../functions';
import { FollowUpInputCommand } from './types';

type Params = {
  sendMessage(message: string): void;
  sendLabel(label: string): void;
};

export const createFollowUpCommandHandler = (params: Params) => {
  const { sendMessage, sendLabel } = params;

  return (cmd: FollowUpInputCommand) => {
    const {
      data: { delay, input, input_type },
    } = cmd;

    if (!input) return;

    const send = (message: string) => {
      if (input_type === 'label') {
        sendLabel(message);
      } else {
        sendMessage(message);
      }
    };

    if (delay) {
      setTimeout(() => {
        send(input);
      }, parseInt(delay));
    } else {
      send(input);
    }
  };
};

export const handleFollowupInputCommand = createFollowUpCommandHandler({
  sendMessage(message) {
    sendChatMessage(message, { silent: true });
  },
  sendLabel(label) {
    sendBackgroundMessage(label);
  },
});
